import type { World } from './world.js';
import type { EngineConfig, PickupKind } from '../types.js';
import type { Prng } from '../prng.js';
import type { Pickup } from './entities.js';

const CYCLE: PickupKind[] = ['spread', 'laser', 'homing', 'shield'];
const CYCLE_MS = 1800;

/**
 * Called on enemy kill: rolls drop chance and spawns a pickup.
 */
export function maybeDropPickup(
  world: World,
  pos: { x: number; y: number },
  config: EngineConfig,
  rng: Prng
): void {
  if (rng() >= config.pickups.dropChance) return;
  // Initial weapon is chosen from PRNG too.
  const idx = Math.floor(rng() * CYCLE.length) % CYCLE.length;
  const weapon = CYCLE[idx]!;
  world.spawnPickup({
    pos,
    fallSpeed: config.pickups.fallSpeed,
    weapon,
  });
}

/**
 * Derives the currently-displayed pickup kind from a pickup's age.
 */
export function currentPickupWeapon(pk: Pickup): PickupKind {
  const baseIdx = CYCLE.indexOf(pk.weaponAtSpawn);
  const step = Math.floor(pk.ageMs / CYCLE_MS) % CYCLE.length;
  return CYCLE[(baseIdx + step + CYCLE.length) % CYCLE.length]!;
}
